<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <!--INICIO NUEVO TRATAMIENTO-->
    <b-tabs class="md-transparent borderGray">
      <b-tab lazy
             id="tab-clinicasactivas"
             title="DATOS GENERALES"
             class="borderGray paddingTab"
             v-if="$localStorageService.can('Cat_Tx_dtosGen')"
      >
        <b-row>
          <b-col>
            <p style="color: #17a2b8; font-weight: 600" class="mt-2">DATOS GENERALES</p>
          </b-col>
          <b-col class="text-right mr-5">
            <b-button   class="paddingbotones botonesAzulFuerte" v-b-modal.modal-1 variant="primary"
                      v-b-tooltip.hover
                      title="Asignar clínicas"
            ><em class="clinica_svg icon-boton"></em></b-button
            >
          </b-col>
        </b-row>
        <div class="scrollPorTabs">
          <b-row cols="1" cols-md="2" cols-lg="4" class="mr-3">
            <b-col>
              <b-form-group align="left">
                <label>Nombre del tratamiento
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-form-input
                      class="redondeo"
                      id="idNombre"
                      placeholder="Ingrese el nombre tratamiento"
                      v-model="tratamiento.nombre"
                      :state="tratamiento.nombre != null && tratamiento.nombre != '' "
                  ></b-form-input>
                  <b-form-invalid-feedback :state="tratamiento.nombre != null && tratamiento.nombre != ''">
                    Se debe colocar el nombre
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Nombre corto del tratamiento
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-form-input
                      id="idNombre"
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Ingrese el nombre corto"
                      v-model="tratamiento.nombreAbreviado"
                      :state="tratamiento.nombreAbreviado != null && tratamiento.nombreAbreviado != ''"
                  ></b-form-input>
                  <b-form-invalid-feedback :state="tratamiento.nombreAbreviado != null && tratamiento.nombreAbreviado != ''">
                    Se debe colocar el nombre abreviado
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Especialidad origen
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona la especialidad origen"
                      :options="especialidadArrayOrigen"
                      :reduce="(esp) => esp.value"
                      label="text"
                      v-model="tratamiento.idEspecialidadOrigen"
                      :state="tratamiento.idEspecialidadOrigen!= null"
                  />
                  <b-form-invalid-feedback :state="tratamiento.idEspecialidadOrigen != null">
                    Selecionar especialidad
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Perfil laboral
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona el perfil laboral"
                      :options="especialidadArrayCrear"
                      :reduce="(esp) => esp.value"
                      label="text"
                      v-model="especialidadesArray"
                      multiple
                      :state="especialidadesArray != 0"
                  />
                  <b-form-invalid-feedback :state="especialidadesArray != 0">
                    Selecionar perfil laboral
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row cols="1" cols-md="2" cols-lg="4" class="mr-3">
            <b-col>
              <b-form-group align="left">
                <label>Categoria
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona la categoria"
                      :options="categoriaArray"
                      :reduce="(cat) => cat.value"
                      label="text"
                      v-model="tratamiento.idCategoria"
                      :state="tratamiento.idCategoria != null"
                  />
                  <b-form-invalid-feedback :state="tratamiento.idCategoria != null">
                    Selecionar categoria
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Riesgo
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona el riesgo"
                      :options="riesgoArray"
                      :reduce="(riesgo) => riesgo.value"
                      label="text"
                      v-model="tratamiento.idRiesgo"
                      :state="tratamiento.idRiesgo != null"
                  />
                  <b-form-invalid-feedback :state="tratamiento.idRiesgo!= null">
                    Selecionar riesgo
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Sesiones Mínimas
                  <validacion/>
                </label>
                <b-form-select
                    class="redondeo"
                    style="width: 100%;"
                    v-model="tratamiento.minimoSessiones"
                    @change="crearArrayMin(tratamiento.minimoSessiones)"
                    :options="sesionesArray"
                    :state="tratamiento.minimoSessiones != null"
                ></b-form-select>
                <b-form-invalid-feedback :state="tratamiento.minimoSessiones != null">
                  Selecionar Sesiones minimas
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Categoría de tratamiento
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona la categoría del tratamiento"
                      :options="categoriasTratamiento"
                      :reduce="(cat) => cat.idCategoria"
                      label="descripcion"
                      v-model="tratamiento.idCategoriaTratamiento"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row cols="1" cols-md="2" cols-lg="4" class="mr-3">
            <b-col>
              <b-form-group align="left">
                <label>Subcategoría de tratamiento
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona la subcategoría del tratamiento"
                      :options="subcategoriasTratamiento"
                      :reduce="(cat) => cat.value"
                      label="text"
                      v-model="tratamiento.idSubcategoriaTratamiento"
                      :disabled="tratamiento.idCategoriaTratamiento == null"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Estatus
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona el estatus"
                      :options="estatusCategoria"
                      :reduce="(cat) => cat.idEstatusCategoria"
                      label="descripcionEstatus"
                      v-model="tratamiento.idEstatusCategoria"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Sesiones maximas
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-form-select
                      class="redondeo"
                      style="width: 100%;"
                      v-model="tratamiento.maximoSesiones"
                      :options="sesionesArrayMax"
                      :disabled="tratamiento.minimoSessiones == null"
                      :state="tratamiento.maximoSesiones != null"
                  ></b-form-select>
                  <b-form-invalid-feedback :state="tratamiento.maximoSesiones != null">
                    Se debe colocar sesión máxima
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Ponderación
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-form-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona la ponderación"
                      v-model="tratamiento.ponderacion"
                      :options="ponderacionArray"
                      :state="tratamiento.ponderacion != null"
                  ></b-form-select>
                  <b-form-invalid-feedback :state="tratamiento.ponderacion != null">
                    Se debe colocar ponderación
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Tipo Paciente
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <v-select
                      class="redondeo"
                      style="width: 100%;"
                      label="descripcion"
                      placeholder="Selecciona niño, adulto o mixto "
                      :options="adultoNinoArray"
                      :reduce="(variable) => variable.idDenticion"
                      v-model="tratamiento.idDenticion"
                      :state="tratamiento.idDenticion != null"
                  />
                  <b-form-invalid-feedback :state="tratamiento.idDenticion != null">
                  Se debe colocar opción
                </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <label>¿A que consentimiento aplica?
              </label>
              <b-input-group size="sm" class="mb-2">
                <v-select
                    class="redondeo"
                    style="width: 100%;"
                    placeholder="Selecciona el consentimiento"
                    v-model="tratamiento.consentimiento"
                    :options="consentimientoArray"
                    label="nombre"
                    multiple
                />
              </b-input-group>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="mt-4 mr-1">
                  <b-form-checkbox v-model="tratamiento.complemento" switch>
                    ¿Tiene complemento?
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-col class="mt-4 ml-3">
                <b-form-checkbox v-model="tratamiento.emergencia" switch>
                  ¿Es tratamiento de emergencia?
                </b-form-checkbox>
              </b-col>
            </b-col>
          </b-row>
          <b-row  cols="1" cols-md="2" cols-lg="4" class="mr-3">
            <b-col>
              <b-row>
                <b-col class="mt-4 ml-5">
                  <b-form-checkbox v-model="laboratorio" switch>
                    ¿Pasa por laboratorio?
                  </b-form-checkbox>
                  <b-form-group align="left" v-if="laboratorio">
                    <label>¿Cuántos días tarda en laboratorio?
                    </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                          class="redondeo"
                          style="width: 100%;"
                          placeholder="Ingrese los días tarda en la laboratorio"
                          type="number"
                          min="0"
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-form-group align="left">
              <label>Descripción
                <validacion/>
              </label>
                <b-form-textarea
                    v-model="tratamiento.descripcion"
                    rows="3"
                    max-rows="6"
                    :state="tratamiento.descripcion != null "
                ></b-form-textarea>
                <b-form-invalid-feedback :state="tratamiento.descripcion != null">
                  Se debe colocar descripción
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label>Descripción al Paciente
                  <validacion/>
                </label>
                <b-form-textarea
                    v-model="tratamiento.descripcionPx"
                    rows="3"
                    max-rows="6"
                    :state="tratamiento.descripcionPx != null"
                ></b-form-textarea>
                <b-form-invalid-feedback :state="tratamiento.descripcionPx != null">
                  Se debe colocar descripción al paciente
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab lazy
             id="tab-clinicasactivas"
             title="PRECIOS Y COMISIONES"
             class="borderGray paddingTab"
             v-if="$localStorageService.can('Cat_Tx_precios_comi')"
      >
          <p style="color: #17a2b8; font-weight: 600" class="mt-2">  Precios y comisiones</p>
        <b-row class="scrollPorTabs">
          <b-col class="col-12 col-sm-12 col-md-9">
          <b-row class="mr-3">
            <b-col class="col-12 col-sm-12 col-md-4">
              <b-form-group align="left">
                <label>¿En cuántas sesiones se paga el tratamiento?
                  <validacion/>
                </label>
                <b-input-group size="sm">
                  <b-form-select
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona el número de sesiones"
                      v-model="tratamiento.numeroSesionesPagar"
                      :options="sesionesArrayMinMax"
                      :disabled="
                  tratamiento.minimoSessiones == null ||
                  tratamiento.maximoSesiones == null
                "
                      :state="tratamiento.numeroSesionesPagar != null "
                  ></b-form-select>
                  <b-form-invalid-feedback :state="tratamiento.numeroSesionesPagar != null">
                    Se debe colocar opción
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col class="col-12 col-sm-12 col-md-4">
              <b-form-group align="left">
                <label>¿En que sesiones se paga el tratamiento?
                </label>
                <b-input-group size="sm">
                    <v-select
                        class="redondeo"
                        style="width: 100%;"
                        placeholder="Selecciona el número de sesiones"
                        :options="sesionesArrayMinMax"
                        :reduce="(esp) => esp.value"
                        label="text"
                        v-model="tratamiento.sesiones"
                        :disabled="
                  tratamiento.minimoSessiones == null ||
                  tratamiento.maximoSesiones == null
                "
                        :state="tratamiento.sesiones != 0 "
                        multiple
                    ></v-select>
                    <b-form-invalid-feedback :state="tratamiento.sesiones != 0">
                      Se debe colocar opción
                    </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col class="col-12 col-sm-12 col-md-4">
              <b-form-group align="left">
                <label>¿En que sesiones se paga el tratamiento?
                  <validacion/>
                </label>
                <b-input-group size="sm">
                  <b-form-input
                      class="redondeo"
                      style="width: 100%;"
                      placeholder="Selecciona el número de sesiones"
                      v-model="tratamiento.costoTratamiento"
                      type="number"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mr-3">
            <b-col class="col-12 col-sm-12 col-md-4">
              <b-form-group align="left">
                <label>Ponderacion (Bloque):
                </label>
                <b-input-group size="sm">
                  <b-form-select
                      class="redondeo"
                      style="width: 100%;"
                      v-model="tratamiento.ponderacionBloque"
                      type="number"
                      :options="opciones"
                  ></b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col class="col-12 col-sm-12 col-md-4">
              <b-row>
                <b-col class="mt-4 mr-1">
                  <b-form-checkbox switch v-model="aplicaTodasZonas">
                    Aplica en todas las zonas
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
            <!-- no aplica todas -->
              <b-row class="contenedorTablaSinColor m-1">
            <b-table
                responsive
                hover
                :items="arrayZonas"
                :fields="fieldsZonas"
                thead-tr-class="columnasTablaSinColor"
                v-bind="arrayZonas"
                v-if="aplicaTodasZonas == false"
            >
              <template #cell(nombreZona)="data">
                {{ data.value }}
              </template>

              <template v-slot:cell()="{ item, field: { key } }">
              <span v-if="key == 'precio'">
                <b-form-input
                    v-model="item[key]"
                    :min="0"
                    step="1"
                    type="number"
                    @keydown="filterKey"
                    @input="filterInput"
                ></b-form-input>
              </span>

                <span v-else-if="key == 'precioExtranjero'">
                <b-form-input
                    v-model="item[key]"
                    :min="0"
                    step="1"
                    type="number"
                    @keydown="filterKey"
                    @input="filterInput"
                ></b-form-input>
              </span>

                <span v-else>
                <b-form-input
                    v-model="item[key]"
                    :min="0"
                    step="1"
                    type="number"
                ></b-form-input>
              </span>
              </template>
            </b-table>

            <!-- aplica todas -->
            <b-table
                responsive
                hover
                :items="arrayZonaTodas"
                :fields="fieldsZonas"
                thead-tr-class="columnasTablaSinColor"
                v-bind="arrayZonaTodas"
                v-else
                class="contenedorTablaSinColor"
            >
              <template #cell(nombreZona)="data">
                {{ data.value }}
              </template>

              <template v-slot:cell()="{ item, field: { key } }">
              <span v-if="key == 'precio'">
                <b-form-input
                    v-model="item[key]"
                    :min="0"
                    step="1"
                    type="number"
                    @keydown="filterKey"
                    @input="filterInput"
                ></b-form-input>
              </span>

                <span v-else-if="key == 'precioExtranjero'">
                <b-form-input
                    v-model="item[key]"
                    :min="0"
                    step="1"
                    type="number"
                    @keydown="filterKey"
                    @input="filterInput"
                ></b-form-input>
              </span>

                <span v-else>
                <b-form-input
                    v-model="item[key]"
                    :min="0"
                    step="1"
                    type="number"
                ></b-form-input>
              </span>
              </template>
            </b-table>
              </b-row>
            </b-col>
          </b-row>
          </b-col>
          <b-col class="col-12 col-sm-12 col-md-3">
               <div>
                 <b-col cols="12" class="contenedorTablaSinColor mt-1" >
                   <br>
                   <b-col class="mb-2">
                     <span style="color: #0c69a7; font-weight: 600">Opciones de tratamiento</span>
                   </b-col>
                   <div class="ml-2 mr-2 mt-3">
                   <b-form-checkbox
                       v-model="tratamiento.todosDientes"
                       switch
                       size="sm"
                   >
                     <label>Boca completa</label>
                   </b-form-checkbox>
                   <b-form-checkbox
                       v-model="tratamiento.redKobe"
                       switch
                       size="sm"
                   >
                     <label>Tratamiento para Red KOBE</label>
                   </b-form-checkbox>
                   <b-form-checkbox
                       v-model="tratamiento.sinPoh"
                       switch
                       size="sm"
                   >
                     <label>Puede ir sin PoH</label>
                   </b-form-checkbox>
                   <b-form-checkbox
                       v-model="tratamiento.bip"
                       switch
                       size="sm"
                   >
                     <label>Cuenta para BIP</label>
                   </b-form-checkbox>
                   <b-form-checkbox
                       v-model="tratamiento.bonoReferencia"
                       switch
                       size="sm"
                   >
                     <label>Bono de referencia</label>
                   </b-form-checkbox>
                   <b-form-checkbox
                       v-model="tratamiento.cantidad"
                       switch
                       size="sm"
                   >
                     <label>Cantidad</label>
                   </b-form-checkbox>
                   <b-form-checkbox
                       v-model="tratamiento.sinPlan"
                       switch
                       size="sm"
                   >
                     <label>Puede asignarse sin plan de tratamiento</label>
                   </b-form-checkbox>
                   <b-form-checkbox
                       v-model="tratamiento.ligadoOd"
                       switch
                       size="sm"
                   >
                     <label>Ligado a un OD</label>
                   </b-form-checkbox>
                   <b-form-checkbox
                       v-model="tratamiento.avpt"
                       switch
                       size="sm"
                   >
                     <label>Válido para AVPT</label>
                   </b-form-checkbox>
                   <b-form-checkbox
                       v-model="tratamiento.avptSdi"
                       switch
                       size="sm"
                   >
                     <label>Válido para AVPT SDI</label>
                   </b-form-checkbox>
                   <b-form-checkbox
                       v-model="tratamiento.hdx"
                       switch
                       size="sm"
                   >
                     <label>Herramienta Dx</label>
                   </b-form-checkbox>
                     </div>
                 </b-col>
               </div>
          </b-col>
        </b-row>
        <div  class="text-center"  v-if="!$localStorageService.can('BO_35_tx_tiemposugerido')">
          <b-button
              variant="primary"
              class="botonesAzulFuerte"
              :disabled="
                banderaNombre ||
                tratamiento.nombre == '' ||
                tratamiento.nombreAbreviado == '' ||
                especialidadesArray.length == 0 ||
                tratamiento.idCategoria == '' ||
                tratamiento.idRiesgo == '' ||
                tratamiento.minimoSessiones == '' ||
                tratamiento.maximoSesiones == '' ||
                tratamiento.idEspecialidadOrigen == null ||
                tratamiento.sesiones == '' ||
                tratamiento.descripcion == null ||
                tratamiento.descripcionPx == null ||
                btnDisabled == true
              "
              @click="crearTrt"
          >
            <span v-if="!btnDisabled">Guardar</span>
            <span v-else> <b-spinner small></b-spinner> Cargando...</span>
          </b-button>
          <b-button  variant="secondary" class="m-3 botonesGrisFuerte" @click="cerrarModalAlta()">
            Cancelar
          </b-button>
        </div>
      </b-tab>
      <b-tab lazy
             id="tab-clinicasactivas"
             title="TIEMPO SUGERIDO"
             class="borderGray paddingTab"
             v-if="$localStorageService.can('BO_35_tx_tiemposugerido')"
      >
        <b-col>
          <p style="color: #17a2b8; font-weight: 600" class="mt-2">Tiempo sugerido</p>
        </b-col>
        <div class="scrollPorTabs">
          <b-row class="ml-1" v-if="!tratamiento.varianteTiempo">
            <b-col class="col-12 col-sm-12 col-md-2">
              <b-row>
                <b-col class="mt-1 mr-1">
                  <b-form-checkbox switch v-model="tratamiento.varianteTiempo">
                    ¿Variante de tiempo?
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="ml-1" v-if="!tratamiento.varianteTiempo">
            <b-col class="col-12 col-sm-12 col-md-4">
              <b-form-group align="left">
                <label>Tiempo mínimo por tratamiento
                  <validacion/>
                </label>
                <br>
                <span style="font-size: 12px">Duración minutos</span>
                <b-input-group size="sm" class="mb-2"
                               style="width: 80%;">
                  <b-input-group-prepend>
                    <b-button variant="outline-secondary" class="border-radius-izquierda " @click="tratamiento.tiempoMinimoTratamiento = tratamiento.tiempoMinimoTratamiento-intervalo"  :disabled="!(tratamiento.tiempoMinimoTratamiento > numeroMinimo)"><em class="menos_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-prepend>
                  <b-form-input style="text-align: center" type="number" min="0" disabled="false" v-model="tratamiento.tiempoMinimoTratamiento"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="outline-secondary" class="border-radius-derecha"  @click="tratamiento.tiempoMinimoTratamiento = intervalo+tratamiento.tiempoMinimoTratamiento"  :disabled="!(tratamiento.tiempoMinimoTratamiento === numeroMinimo || tratamiento.tiempoMinimoTratamiento < numeroMaximo)"><em class="mas_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-append>
                  <b-form-invalid-feedback :state="tratamiento.tiempoMinimoTratamiento > numeroMinimo">
                    Se debe colocar duración minutos
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col  class="col-12 col-sm-12 col-md-4">
              <b-form-group align="left">
                <label>Tiempo sugerido por tratamiento
                  <validacion/>
                </label>
                <br>
                <span style="font-size: 12px">Duración minutos</span>
                <b-input-group size="sm" class="mb-2"
                               style="width: 80%;">
                  <b-input-group-prepend>
                    <b-button variant="outline-secondary" class="border-radius-izquierda " @click="tratamiento.tiempoSugeridoTratamiento = tratamiento.tiempoSugeridoTratamiento-intervalo"  :disabled="!(tratamiento.tiempoSugeridoTratamiento > numeroMinimo)"><em class="menos_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-prepend>
                  <b-form-input style="text-align: center" type="number" min="0" disabled="false" v-model="tratamiento.tiempoSugeridoTratamiento"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="outline-secondary" class="border-radius-derecha"  @click="tratamiento.tiempoSugeridoTratamiento = intervalo+tratamiento.tiempoSugeridoTratamiento"  :disabled="!(tratamiento.tiempoSugeridoTratamiento === numeroMinimo || tratamiento.tiempoSugeridoTratamiento < numeroMaximo)"><em class="mas_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-append>
                  <b-form-invalid-feedback :state="tratamiento.tiempoSugeridoTratamiento > numeroMinimo">
                    Se debe colocar duración minutos
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col  class="col-12 col-sm-12 col-md-4">
              <b-form-group align="left">
                <label>Tiempo máximo por tratamiento
                  <validacion/>
                </label>
                <br>
                <span style="font-size: 12px">Duración minutos</span>
                <b-input-group size="sm" class="mb-2"
                               style="width: 80%;">
                  <b-input-group-prepend>
                    <b-button variant="outline-secondary" class="border-radius-izquierda " @click="tratamiento.tiempoMaximoTratamiento = tratamiento.tiempoMaximoTratamiento -intervalo"  :disabled="!(tratamiento.tiempoMaximoTratamiento  > numeroMinimo)"><em class="menos_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-prepend>
                  <b-form-input style="text-align: center" type="number" min="0" disabled="false" v-model="tratamiento.tiempoMaximoTratamiento "></b-form-input>
                  <b-input-group-append>
                    <b-button variant="outline-secondary" class="border-radius-derecha"  @click="tratamiento.tiempoMaximoTratamiento  = intervalo+tratamiento.tiempoMaximoTratamiento "  :disabled="!(tratamiento.tiempoMaximoTratamiento  === numeroMinimo || tratamiento.tiempoMaximoTratamiento  < numeroMaximo)"><em class="mas_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-append>
                  <b-form-invalid-feedback :state="tratamiento.tiempoMaximoTratamiento  > numeroMinimo">
                    Se debe colocar duración minutos
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="tratamiento.varianteTiempo">
            <b-col class="col-12 col-sm-12 col-md-4">
              <b-form-checkbox switch v-model="tratamiento.varianteTiempo" class="ml-3">
                ¿Variante de tiempo?
              </b-form-checkbox>
          <div>
            <b-col>
              <b-form-group align="left">
                <label>Tiempo mínimo por tratamiento
                  <validacion/>
                </label>
                <br>
                <span style="font-size: 12px">Duración minutos</span>
                <b-input-group size="sm" class="mb-2"
                               style="width: 80%;">
                  <b-input-group-prepend>
                    <b-button variant="outline-secondary" class="border-radius-izquierda " @click="tratamiento.tiempoMinimoTratamiento = tratamiento.tiempoMinimoTratamiento-intervalo"  :disabled="!(tratamiento.tiempoMinimoTratamiento > numeroMinimo)"><em class="menos_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-prepend>
                  <b-form-input style="text-align: center" type="number" min="0" disabled="false" v-model="tratamiento.tiempoMinimoTratamiento"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="outline-secondary" class="border-radius-derecha"  @click="tratamiento.tiempoMinimoTratamiento = intervalo+tratamiento.tiempoMinimoTratamiento"  :disabled="!(tratamiento.tiempoMinimoTratamiento === numeroMinimo || tratamiento.tiempoMinimoTratamiento < numeroMaximo)"><em class="mas_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-append>
                  <b-form-invalid-feedback :state="tratamiento.tiempoMinimoTratamiento > numeroMinimo">
                    Se debe colocar duración minutos
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </div>
          <div>
            <b-col>
              <b-form-group align="left">
                <label>Tiempo sugerido por tratamiento
                  <validacion/>
                </label>
                <br>
                <span style="font-size: 12px">Duración minutos</span>
                <b-input-group size="sm" class="mb-2"
                               style="width: 80%;">
                  <b-input-group-prepend>
                    <b-button variant="outline-secondary" class="border-radius-izquierda " @click="tratamiento.tiempoSugeridoTratamiento = tratamiento.tiempoSugeridoTratamiento-intervalo"  :disabled="!(tratamiento.tiempoSugeridoTratamiento > numeroMinimo)"><em class="menos_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-prepend>
                  <b-form-input style="text-align: center" type="number" min="0" disabled="false" v-model="tratamiento.tiempoSugeridoTratamiento"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="outline-secondary" class="border-radius-derecha"  @click="tratamiento.tiempoSugeridoTratamiento = intervalo+tratamiento.tiempoSugeridoTratamiento"  :disabled="!(tratamiento.tiempoSugeridoTratamiento === numeroMinimo || tratamiento.tiempoSugeridoTratamiento < numeroMaximo)"><em class="mas_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-append>
                  <b-form-invalid-feedback :state="tratamiento.tiempoSugeridoTratamiento > numeroMinimo">
                    Se debe colocar duración minutos
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </div>
          <div>
            <b-col>
              <b-form-group align="left">
                <label>Tiempo máximo por tratamiento
                  <validacion/>
                </label>
                <br>
                <span style="font-size: 12px">Duración minutos</span>
                <b-input-group size="sm" class="mb-2"
                               style="width: 80%;">
                  <b-input-group-prepend>
                    <b-button variant="outline-secondary" class="border-radius-izquierda " @click="tratamiento.tiempoMaximoTratamiento = tratamiento.tiempoMaximoTratamiento-intervalo"  :disabled="!(tratamiento.tiempoMaximoTratamiento > numeroMinimo)"><em class="menos_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-prepend>
                  <b-form-input style="text-align: center" type="number" min="0" disabled="false" v-model="tratamiento.tiempoMaximoTratamiento"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="outline-secondary" class="border-radius-derecha"  @click="tratamiento.tiempoMaximoTratamiento = intervalo+tratamiento.tiempoMaximoTratamiento"  :disabled="!(tratamiento.tiempoMaximoTratamiento === numeroMinimo || tratamiento.tiempoMaximoTratamiento < numeroMaximo)"><em class="mas_gris_svg primary sm botones-control"></em></b-button>
                  </b-input-group-append>
                  <b-form-invalid-feedback :state="tratamiento.tiempoMaximoTratamiento > numeroMinimo">
                    Se debe colocar duración minutos
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </div>
            </b-col>
            <b-col class="col-12 col-sm-12 col-md-4">
              <div>
                <b-col cols="12" class="contenedorTablaSinColor" style="height: 80vh; !important;">
                  <br>
                  <b-row>
                    <b-col>
                      <b-form-group align="left">
                        <label>  <span style="color: #0c69a7; font-weight: 600">Variaciones de tiempo</span>
                          <validacion/>
                        </label>
                        <b-input-group size="sm" class="mb-2">
                          <b-form-input
                              class="redondeo"
                              id="idNombre"
                              placeholder="Ingrese el nombre variacion de tiempo"
                              v-model="tratamiento.variacionesTiempo"
                              :state="tratamiento.variacionesTiempo != null && tratamiento.variacionesTiempo != '' "
                          ></b-form-input>
                          <b-form-invalid-feedback :state="tratamiento.variacionesTiempo != null && tratamiento.variacionesTiempo != ''">
                            Se debe colocar el nombre variacion de tiempo
                          </b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="ml-2 mr-2">
                      <b-form-group align="left">
                        <label> <span style="color: #0c69a7; font-weight: 600">Opciones</span>
                          <validacion/>
                        </label>
                        <b-input-group size="sm" class="mb-2 contenedorInputSinColor variacion-opciones" >
                          <b-form-input
                              class="redondeo m-1"
                              id="opcion"
                              placeholder="Nueva respuesta"
                              v-model="nuevaOpcion.descripcionOpcion"
                          ></b-form-input>
                          <em class="mas_azul_svg sm mr-2 ml-2" @click="agregarOpcion()"></em>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-for="(opcion, index) in tratamiento.listaOpcionesVariacionesTiempo" :key="index" class="ml-2 mr-2 mt-2 contenedorInputSinColor">
                    <b-col class="text-left mt-2">
                       <p>{{opcion.descripcionOpcion}}</p>
                    </b-col>
                    <b-col class="text-end mt-2">
                      <em v-if="!opcion.editar" class="editar-naranja-svg ml-2 " v-b-tooltip.hover
                          title="Editar" @click="editarActivo(opcion, index)"></em>
                      <em v-if="!opcion.registroActivo" class="desactivo-rojo-svg ml-2 " v-b-tooltip.hover
                          title="Desactivado" @click="activarDesactivarOpcion(true, index)"></em>
                      <em  v-else class="activo-verde-svg ml-2" v-b-tooltip.hover
                           title="Activo"   @click="activarDesactivarOpcion(false, index)"></em>
                    </b-col>
                  </b-row>
                </b-col>
              </div>
            </b-col>
            <b-col class="col-12 col-sm-12 col-md-4">
              <div>
                <b-col cols="12" class="contenedorTablaSinColor" style="height: 80vh; !important;">
                  <br>
                  <b-col class="mb-2">
                    <span style="color: #0c69a7; font-weight: 600">Información de ayuda al anfitrión</span>
                    <validacion/>
                  </b-col>
                  <div>
                  <VueEditor v-model="tratamiento.infoAyudaAnfitrion"></VueEditor>
                  </div>
                </b-col>
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="text-center">
          <b-button
              variant="primary"
              class="botonesAzulFuerte"
              :disabled="
                banderaNombre ||
                tratamiento.nombre == '' ||
                tratamiento.nombreAbreviado == '' ||
                especialidadesArray.length == 0 ||
                tratamiento.idCategoria == '' ||
                tratamiento.idRiesgo == '' ||
                tratamiento.minimoSessiones == '' ||
                tratamiento.maximoSesiones == '' ||
                tratamiento.idEspecialidadOrigen == null ||
                tratamiento.sesiones == '' ||
                tratamiento.descripcion == null ||
                tratamiento.descripcionPx == null ||
                btnDisabled == true ||
                (tratamiento.varianteTiempo == true && (tratamiento.variacionesTiempo == null || tratamiento.variacionesTiempo == '' || tratamiento.variacionesTiempo.trim() == ''))||
                (tratamiento.tiempoMinimoTratamiento == 0 ||
                 tratamiento.tiempoSugeridoTratamiento == 0 ||
                 tratamiento.tiempoMaximoTratamiento == 0 )
              "
              @click="crearTrt"
          >
            <span v-if="!btnDisabled && $localStorageService.can('Cat_Tx_btn_guardar')">Guardar</span>
            <span v-else> <b-spinner small></b-spinner> Cargando...</span>
          </b-button>
          <b-button  variant="secondary" class="m-3 botonesGrisFuerte" @click="cerrarModalAlta()">
            Cancelar
          </b-button>
        </div>
      </b-tab>
    </b-tabs>

    <!--FIN NUEVO TRATAMIENTO-->
    <b-modal id="modal-1" title="Asigar Clínicas/Estados" hide-footer>
      <b-input-group size="sm">
        <b-form-input
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="Buscar"
        ></b-form-input>
        <b-input-group-append>
          <b-button :disabled="!filter" @click="filter = ''">Limpiar </b-button>
        </b-input-group-append>
      </b-input-group>
      <div class="botonesSeleccion">
        <b-button size="sm" @click="selectAllRows" variant="outline-primary"
        >Seleccionar todo</b-button
        >
        <b-button
            size="sm"
            @click="clearSelected"
            variant="outline-danger"
            style="margin-left: 10px"
        >Inactivar todo</b-button
        >
      </div>
      <b-table
          responsive="sm"
          sticky-header
          :items="clinicas"
          :fields="fieldsClinicas"
          :filter="filter"
          :filter-included-fields="filterOn"
          v-bind="clinicas"
          thead-tr-class="columnas"
      >
        <template #cell(selected)="data">
          <b-form-checkbox
              v-model="data.item.selected"
              name="checkbox"
              :value="true"
          >
          </b-form-checkbox>
        </template>
      </b-table>
      <div class="btnsBottom">
        <b-button
            variant="outline-primary"
            size="sm"
            @click="$bvModal.hide('modal-1')"
        >Guardar</b-button
        >

        <b-button
            style="margin-left: 10px"
            variant="outline-danger"
            size="sm"
            @click="cerrarModal"
        >Cancelar</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import miniToastr from "mini-toastr"; //ES6
import {VueEditor} from "vue2-editor";
export default {
  name: "altaTratamiento",
  props: {
    msg: String,
  },
  components: {VueEditor},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    showOptions: false,
    laboratorio: false,
    banderaNombre: false,
    especialidadArray: [],
    especialidadArrayCrear: [],
    especialidadArrayOrigen: [],

    adultoNinoArray: [],

    descripcion: "",
    tratamiento: {
      descripcion: null,
      fechaAlta: null,
      fechaModificacion: null,
      idCategoria: null,
      especialidades: [],
      sesiones: [],
      adultoNinoArray: [],
      idMaterial: null,
      idRiesgo: null,
      idTratamiento: null,
      idUsuarioAlta: null,
      idUsuarioModificacion: null,
      idDenticion: null,
      maximoSesiones: null,
      minimoSessiones: null,
      monitoreado: true,
      nombre: null,
      nombreAbreviado: null,
      nombreCategoria: null,
      nombreEspecialidad: null,
      nombreMaterial: null,
      nombreRiesgo: null,
      registroActivo: true,
      variasSesiones: true,
      avptSdi: false,
      avpt: false,
      sinPoh: false,
      redKobe: false,
      cantidad: false,
      hdx: false,
      bip: false,
      bonoReferencia: false,
      sinPlan: false,
      ligadoOd: false,
      todosDientes: false,
      numeroSesionesPagar: null,
      ponderacion: 1,
      complemento: false,
      costoTratamiento: 0,
      descripcionPx: null,
      emergencia: false,
      varianteTiempo: false,
      tiempoMinimoTratamiento: 0,
      tiempoSugeridoTratamiento:0,
      tiempoMaximoTratamiento:0,
      variacionesTiempo: null,
      listaOpcionesVariacionesTiempo: [],
      infoAyudaAnfitrion: null
    },
    riesgoArray: [
      {
        value: 1,
        text: "BAJO",
      },
      {
        value: 2,
        text: "MEDIO",
      },
      {
        value: 3,
        text: "ALTO",
      },
      {
        value: 4,
        text: "MUY ALTO",
      },
    ],
    sesionesArray: [],
    sesionesArrayMax: [],
    sesionesArrayMinMax: [],
    ponderacionArray: [],
    categoriaArray: [],
    btnDisabled: false,
    arrayZonas: [], //ZONAS
    arrayZonaTodas: [
      {
        bonoIndividualOg: null,
        bonoTrimestral: null,
        comisionBaseEspecialistas: null,
        comisionBaseOG: null,
        comisionMasBonoEspecialistas: null,
        idZona: 10,
        precio: null,
        precioExtranjero: null,
        registroActivo: true,
        nombreZona: "TODAS",
      },
    ],
    aplicaTodasZonas: false,
    fieldsZonas: [
      {
        key: "nombreZona",
        label: "Zona",
      },
      {
        key: "precio",
        label: "Precio",
      },
      {
        key: "precioExtranjero",
        label: "Precio Extranjero",
      },
      {
        key: "bonoIndividualOg",
        label: "Bono individual OG's",
      },
      {
        key: "comisionBaseEspecialistas",
        label: "Comisión base especialistas",
      },
      {
        key: "comisionMasBonoEspecialistas",
        label: "Comisión más bono especialistas",
      },
      {
        key: "bonoTrimestral",
        label: "Bono trimestral OG's",
      },
      {
        key: "comisionBaseOG",
        label: "Comisión base OG's",
      },
      {
        key: "comisionMultiplicador",
        label: "Comision base especialista multiplicador",
      },
    ],
    clinicas: [],
    fieldsClinicas: [
      { key: "idClinica", label: "ID", sortable: true, sortDirection: "desc" },
      {
        key: "strNombre",
        label: "Nombre",
        sortable: true,
        sortDirection: "desc",
      },
      {
        key: "selected",
        label: "Selección",
      },
    ],
    filter: null,
    filterOn: [],
    selectMode: "multi",
    especialidadesArray: [],
    opciones: [1,2,3,4,5,6,7,8,9,0.5],
    intervalo: 15,
    numeroMinimo: 0,
    numeroMaximo:480,
    nuevaOpcion:{idOpcion: null, descripcionOpcion: "", registroActivo: true}
  }),

  methods: {
    obtenerTipoDenticion() {
      this.$http
        .get(this.$api + "catalogos/padecimientos/obtener/tipo/denticion")
        .then((r) => {
          if (r.data.data) {
            this.adultoNinoArray = r.data.data;
          }
        });
    },
    checarNombre(nombre) {
      if (nombre.match(/^\s+$/) === null) {
        this.banderaNombre = false;
      } else {
        this.banderaNombre = true;
      }
    },
    filterKey(e) {
      const key = e.key;

      if (key === ".") return e.preventDefault();

      if (key === "e") return e.preventDefault();
    },

    filterInput(e) {
      if (e.target != undefined) {
        e.target.value = e.target.value.replace(/[^0-9]+/g, "");
      }
    },
    cerrarModal() {
      this.$bvModal.hide("modal-1");
    },
    selectAllRows() {
      this.clinicas.forEach((itm) => {
        itm.selected = true;
      });
    },
    clearSelected() {
      this.clinicas.forEach((itm) => {
        itm.selected = false;
      });
    },
    crearTrt() {
      this.arrayZonas.forEach((element) => {
        if (
          element.precio == null ||
          element.precio == "" ||
          element.precio == "0" ||
          element.precio == 0
        ) {
          element.precio = 0;
        }
        if (
          element.precioExtranjero == null ||
          element.precioExtranjero == ""
        ) {
          element.precioExtranjero = 0;
        }
        if (
          element.bonoIndividualOg == null ||
          element.bonoIndividualOg == ""
        ) {
          element.bonoIndividualOg = 0;
        }
        if (element.bonoTrimestral == null || element.bonoTrimestral == "") {
          element.bonoTrimestral = 0;
        }
        if (
          element.comisionBaseEspecialistas == null ||
          element.comisionBaseEspecialistas == ""
        ) {
          element.comisionBaseEspecialistas = 0;
        }
        if (element.comisionBaseOG == null || element.comisionBaseOG == "") {
          element.comisionBaseOG = 0;
        }
        if (
          element.comisionMasBonoEspecialistas == null ||
          element.comisionMasBonoEspecialistas == ""
        ) {
          element.comisionMasBonoEspecialistas = 0;
        }
      });

      this.tratamiento.costoTratamiento =
        this.tratamiento.costoTratamiento == null ||
        this.tratamiento.costoTratamiento === "" ||
        this.tratamiento.length === 0
          ? 0
          : this.tratamiento.costoTratamiento;

      this.tratamiento.fechaAlta = this.$moment(new Date())
        .utc()
        .format("YYYY-MM-DD[T]HH:mm[:00Z]");
      this.tratamiento.fechaModificacion = this.$moment(new Date())
        .utc()
        .format("YYYY-MM-DD[T]HH:mm[:00Z]");

      this.tratamiento.especialidades = this.especialidadesArray.map((it) => {
        return {
          idEspecialidad: it,
          nombreEspecialiadString: "vacio",
        };
      });

      var ArrayClinicasSeleccionadas = this.clinicas.filter(function (item) {
        return item.selected == true;
      });

      this.tratamiento.clinicas = ArrayClinicasSeleccionadas;

      if (ArrayClinicasSeleccionadas.length == 0) {
        this.$swal.fire({
          icon: "info",
          text: "Falta seleccionar una clínica para el tratamiento",
        });
      }else if (this.tratamiento.varianteTiempo && this.tratamiento.listaOpcionesVariacionesTiempo.length == 0) {
        this.$swal.fire({
          icon: "info",
          text: "Falta agregar opciones en variacion de tiempo",
        });
      }else if (this.tratamiento.varianteTiempo && (this.tratamiento.infoAyudaAnfitrion  == "" ||
          this.tratamiento.infoAyudaAnfitrion  == null
          || this.nuevaOpcion.descripcionOpcion.trim() !== "")) {
        this.$swal.fire({
          icon: "info",
          text: "Falta agregar información de ayuda al anfitrión",
        });
      }else {
        this.$swal.fire({
          title: "¿Estás seguro de crear el tratamiento?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.btnDisabled = true;
            this.tratamiento.idMaterial = 1;
            this.tratamiento.idUsuarioAlta =
              this.$localStorageService.getIdUsuario();
            this.tratamiento.idUsuarioModificacion =
              this.$localStorageService.getIdUsuario();
            this.tratamiento.zonaprecios = this.arrayZonas;

            this.$http
              .post(
                this.$api + "tratamientos/crearTratamiento",
                this.tratamiento
              )
              .then((response) => {
                if (response.status === 200) {
                  var message = response.data.message
                    ? response.data.message
                    : "Se guardo correctamente el registro";
                  miniToastr.success(message);

                  this.$swal({
                    icon: "success",
                    title: "Se registro correctamente",
                    showConfirmButton: false,
                    timer: 2500,
                  });
                  location.reload();
                }
              })
              .catch((error) => {
                var message = error.response.data.message
                  ? error.response.data.message
                  : "Error al crear el registro";
                miniToastr.info(message);
                this.btnDisabled = false;
              })
              .finally(() => {
                this.btnDisabled = false;
              });
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
        });
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    llenarEspecialidades() {
      this.$http
        .get(this.$api + "catalogos/obtenerEspecialidades")
        .then((response) => {
          if (response.status === 200) {
            var arrayRespuesta = response.data.data.map((it) => {
              return {
                value: it.id,
                text: it.especialidad,
                color: it.color,
                especialidadOrigen: it.especialidadOrigen,
              };
            });
            this.especialidadArray = arrayRespuesta.filter(function (item) {
              return item.value != 0;
            });

            this.especialidadArrayOrigen = arrayRespuesta.filter(function (
              item
            ) {
              return item.especialidadOrigen;
            });

            this.especialidadArrayCrear = arrayRespuesta.filter(function (
              item
            ) {
              return item.value != 0;
            });

            this.especialidadArray.push({ value: 0, text: "TODAS" });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    llenarCategorias() {
      this.$http
        .get(this.$api + "catalogos/listaCategorias")
        .then((response) => {
          if (response.status === 200) {
            var arrayRespuesta = response.data.data.map((it) => {
              return {
                value: it.idCategoria,
                text: it.descripcion,
              };
            });
            this.categoriaArray = arrayRespuesta.filter(function (item) {
              return item.value != 0;
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
      obtenerCategorias(){
      this.$http.get(this.$api + "catalogos/obtenerListaCategorias").then((response) => {
        this.categoriaTratamientoArray = response.data.data;
        const arrayRespuesta = response.data.data;
        this.categoriasTratamiento = arrayRespuesta;
      })
    },
     obtenerEstatusCategorias() {
      this.$http
        .get(this.$api + "catalogos/obtenerEstatusCategorias")
        .then((response) => {
          const arrayRespuesta = response.data.data;
          this.estatusCategoria = arrayRespuesta;
        })
        .catch((error) => {
          console.error("error", error);
        });
    },

    obtenerSubcategorias(idCategoriaTratamiento){
       let subcat = this.categoriaTratamientoArray.filter(function (item) {
              return item.idCategoria === idCategoriaTratamiento;
            });
        let subcat2 = subcat[0].subCategorias.map((it) => {
              return {
                value: it.idSubcategoriaTratamiento,
                text: it.nombreSubcategoria,
              };
              
            });
        this.subcategoriasTratamiento = subcat2;
    },
    llenarClinicas() {
      this.$http
        .post(this.$api + "catalogos/listaClinicasActivas", {})
        .then((response) => {
          if (response.status === 200) {
            var arrayRespuesta = response.data.data.map((it) => {
              return {
                idClinica: it.idClinica,
                strNombre: it.strNombre,
                selected: false,
              };
            });
            this.clinicas = arrayRespuesta.filter(function (item) {
              return item.idClinica != 0;
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    llenarZonas() {
      this.$http
        .get(this.$api + "catalogos/listaPrecios")
        .then((response) => {
          if (response.status === 200) {
            // this.arrayZonas = response.data.data;

            this.arrayZonas = response.data.data.map(function (el) {
              var o = Object.assign({}, el);
              o.precio = null;
              o.precioExtranjero = null;
              o.bonoIndividualOg = null;
              o.comisionBaseEspecialistas = null;
              o.comisionMasBonoEspecialistas = null;
              o.bonoTrimestral = null;
              o.comisionBaseOG = null;
              return o;
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    crearArrayMin(i) {
      this.sesionesArrayMax = [];
      this.tratamiento.maximoSesiones = null;
      for (let index = i; index < 20; index++) {
        this.sesionesArrayMax.push({
          value: index,
          text: index,
        });
      }
    },
    crearArrayMinMax(i, x) {
      this.sesionesArrayMinMax = [];
      for (let index = 1; index <= x; index++) {
        this.sesionesArrayMinMax.push({
          value: index,
          text: index,
        });
      }
    },
    llenarSesiones() {
      for (let index = 1; index < 20; index++) {
        this.sesionesArray.push({
          value: index,
          text: index,
        });
        this.sesionesArrayMax.push({
          value: index,
          text: index,
        });
        this.sesionesArrayMinMax.push({
          value: index,
          text: index,
        });
      }
    },
    llenarPonderacion() {
      for (let index = 0; index <= 10; index++) {
        this.ponderacionArray.push({
          value: index,
          text: index,
        });
      }
    },
    transformZonas(valor, keyObj) {
      valor = valor.length === 0 ? 0 : valor;
      this.arrayZonas.forEach((element) => {
        element[keyObj] = valor;
      });
    },
    agregarOpcion(){
      if(this.nuevaOpcion.descripcionOpcion.trim() !== "" && this.nuevaOpcion.descripcionOpcion != "" && this.nuevaOpcion.descripcionOpcion != null) {
        this.tratamiento.listaOpcionesVariacionesTiempo.push(this.nuevaOpcion);
        this.nuevaOpcion = {idOpcion: null, descripcionOpcion: "", registroActivo: true};
        this.tratamiento.listaOpcionesVariacionesTiempo.forEach(o=>{
          o['editar'] = false;
        });
      }
    },
    editarActivo(opcion, index){
      this.nuevaOpcion = opcion;
      this.tratamiento.listaOpcionesVariacionesTiempo.splice(index,1);
      this.tratamiento.listaOpcionesVariacionesTiempo.forEach(o=>{
        o['editar'] = true;
      });
    },
    activarDesactivarOpcion(valor, index){
      this.tratamiento.listaOpcionesVariacionesTiempo[index].registroActivo = valor;
    },
    cerrarModalAlta(){
      this.$emit('cerrarModal', false);
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarClinicas();
    this.llenarEspecialidades();
    this.llenarZonas();
    this.llenarCategorias();
    this.llenarSesiones();
    this.llenarPonderacion();
    this.obtenerTipoDenticion();
        this.obtenerEstatusCategorias();
    this.obtenerCategorias();
    this.obtenerSubcategorias();
  },
  watch: {
    "tratamiento.nombre": function (val) {
      if (val != null) {
        this.checarNombre(val);
      }
    },
    "tratamiento.maximoSesiones": function (val) {
      if (val != null) {
        this.crearArrayMinMax(this.tratamiento.minimoSessiones, val);
      }
    },
     "tratamiento.idCategoriaTratamiento": function (val) {
      if (val != null) {
        this.obtenerSubcategorias(val);
      }
    },
    "arrayZonaTodas.0.bonoIndividualOg": function (val) {
      if (val != null) {
        this.transformZonas(val, "bonoIndividualOg");
      }
    },
    "arrayZonaTodas.0.bonoTrimestral": function (val) {
      if (val != null) {
        this.transformZonas(val, "bonoTrimestral");
      }
    },
    "arrayZonaTodas.0.comisionBaseEspecialistas": function (val) {
      if (val != null) {
        this.transformZonas(val, "comisionBaseEspecialistas");
      }
    },
    "arrayZonaTodas.0.comisionBaseOG": function (val) {
      if (val != null) {
        this.transformZonas(val, "comisionBaseOG");
      }
    },
    "arrayZonaTodas.0.comisionMasBonoEspecialistas": function (val) {
      if (val != null) {
        this.transformZonas(val, "comisionMasBonoEspecialistas");
      }
    },
    "arrayZonaTodas.0.precio": function (val) {
      if (val != null) {
        this.transformZonas(val, "precio");
      }
    },
    "arrayZonaTodas.0.precioExtranjero": function (val) {
      if (val != null) {
        this.transformZonas(val, "precioExtranjero");
      }
    },
  },
};
</script>

<style scoped>
.cardStyle {
  background-color: white;
  margin-top: 1%;
  margin-left: 5%;
  margin-right: 5%;
  padding: 1%;
}

.mginInputTrt {
  padding: 10px;
  width: 100%;
  font-weight: bolder !important;
}

.txtLeft {
  font-weight: bolder;
  text-align: left;
  margin-left: 10px;
}

.displayFlex {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
  padding: 10px;
  padding-bottom: 25px;
  border-bottom: 2px solid #ddd;
}

.itmFlx {
  width: 48%;
  text-align: left;
}

.preCo {
  margin-top: 10px;
  font-size: 18px;
}

.btnClinicas {
  margin: 10px;
  display: flex;
  justify-content: flex-start;
}

.botonesSeleccion {
  margin-top: 10px;
  margin-bottom: 10px;
}

.btnsBottom {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}

.custom-switch {
  text-align: left !important;
  line-height: 2.8 !important;
}
.border-radius-izquierda{
  -webkit-border-top-left-radius: 101px !important;
  -webkit-border-bottom-left-radius: 101px  !important;
  -moz-border-radius-topleft: 101px  !important;
  -moz-border-radius-bottomleft: 101px  !important;
  border-top-left-radius: 9px  !important;
  border-bottom-left-radius: 9px  !important;
}
.border-radius-derecha {
  -webkit-border-top-right-radius: 50px !important;
  -webkit-border-bottom-right-radius: 50px !important;
  -moz-border-radius-topright: 50px !important;
  -moz-border-radius-bottomright: 50px !important;
  border-top-right-radius: 9px !important;
  border-bottom-right-radius: 9px !important;
}
.botones-control{
  font-size: 12px;
  margin-right: 20px;
  margin-left: 20px;
}
.variacion-opciones{
  padding-top: 1.5%;
  padding-bottom: 1.5%;
}
.ql-editor {
  min-height: 50vh !important;
  max-height: 50vh;
}
</style>
